var _defs, _circle, _ellipse, _ellipse2, _ellipse3, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMeetingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e9f3ff;}.cls-2{fill:#008cff;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 24,
    cy: 24,
    r: 24
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 24.09,
    cy: 18.56,
    rx: 4.5,
    ry: 4.31
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 33.62,
    cy: 18.75,
    rx: 3.52,
    ry: 3.37
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 14.87,
    cy: 18.75,
    rx: 3.52,
    ry: 3.37
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.84,33.75H29a1.64,1.64,0,0,0,1.5-1.13,22.76,22.76,0,0,0,.75-4.87c0-1.13-1.88-3.75-7.13-3.75s-7.5,2.25-7.5,3.75S17,33.75,18.84,33.75Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.34,24.38a7.19,7.19,0,0,1,1.13.74c.89.75,1.83,2.25,1.12,6,0,.22.29.18,3.25.19,2.62,0,2.83,0,3.13-.19,1.4-.81,1.5-3.74,1.12-5.24-.2-.82-1.87-2.63-5.25-2.63C31.22,23.25,29.72,24,29.34,24.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M18.66,24.38a6.85,6.85,0,0,0-1.13.75c-.89.74-1.83,2.24-1.12,6,0,.21-.29.17-3.25.18-2.62,0-2.83,0-3.13-.19-1.4-.81-1.5-3.75-1.12-5.25.2-.81,1.87-2.62,5.25-2.62C16.78,23.25,18.28,24,18.66,24.38Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeetingIcon);
export default __webpack_public_path__ + "static/media/meeting-icon.be324b7ce2d735e611cba9360ac56182.svg";
export { ForwardRef as ReactComponent };